import * as types from '../_actions/actionTypes'
import _ from 'lodash'

export function biznumbers(state = {}, action) {
    switch (action.type) {
        case types.FETCH_BIZNUMBERS:
            return {
                ...state,
                ...action.payload,
            }
        case types.FETCH_BIZNUMBERS_FAILURE:
            return state
        case types.UPDATE_BIZNUMBER:
            return _.merge({}, state, action.payload)
        case types.UPDATE_BIZNUMBER_FAILURE:
            return state
        case types.REMOVE_BIZNUMBER:
            return { numbers: _.omit(state.numbers, action.payload) }
        case types.REMOVE_BIZNUMBER_FAILURE:
            return state
        default:
            return state
    }
}
